import { render, staticRenderFns } from "./DataSort.vue?vue&type=template&id=fe5b93c8"
import script from "./DataSort.vue?vue&type=script&lang=js"
export * from "./DataSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports